import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import FormikToggle from '../../../components/Formik/Toggle/FormikToggle'
import Form from '../../Form/Form'
import { FileListItemDto } from '../../../context/FileContext'
import useEntity from '../../../hooks/useEntity'
import useEmailFolders from '../../../hooks/useEmailFolders'
import useUser from '../../../hooks/useUser'
import { Alert } from '@fluentui/react-components/unstable'
import { FormContainerProps, Values } from './LinkEmailFolderDialog'
import { Field, Input, InputOnChangeData } from '@fluentui/react-components'
import ChildFolderCombobox from '../../Combobox/EmailFolder/ChildFolderCombobox'
import RootFolderCombobox from '../../Combobox/EmailFolder/RootFolderCombobox'
import { useTranslation } from 'react-i18next'

export default function FormContent(props: FormContainerProps): ReactElement {
    const [rootFolderId, folders] = useEmailFolders()
    const { email: userEmail } = useUser()
    const { values, setFieldValue, setErrors } = useFormikContext<Values>()
    const context = useFormikContext<Values>()
    const { t: translate } = useTranslation()

    // A 404 result will indicate that the selected folder is available to bind to the current file.
    const [file] = useEntity<FileListItemDto>(id => ({ url: `/email/${userEmail}/folder/${id}/file` }), values.id)

    return (
        <Form globalErrors={props.globalErrors}>
            <FormikToggle
                context={context}
                label={translate('email.filing.synchronize.subtitle')}
                fieldName="create"
                toggleProps={{
                    onChange: (_, value: boolean) => {
                        setErrors(undefined)
                        setFieldValue('create', value)
                    },
                }}
            />
            {values.create ? (
                <>
                    <Field label={translate('email.filing.synchronize.form.rootFolder')} required>
                        <RootFolderCombobox
                            rootFolderId={rootFolderId}
                            folders={folders}
                            selectedOptions={[values.parentFolderId]}
                            onOptionSelect={(_, data) => {
                                setErrors(undefined)
                                setFieldValue('parentFolderId', data.optionValue)
                            }}
                        />
                    </Field>
                    <Field label={translate('email.filing.synchronize.form.folderName')} required>
                        <Input
                            value={values.name}
                            onChange={(_, { value }: InputOnChangeData) => setFieldValue('name', value)}
                        />
                    </Field>
                </>
            ) : (
                <Field label={translate('email.filing.synchronize.form.folderId')} required>
                    <ChildFolderCombobox
                        autoFocus
                        rootFolderId={rootFolderId}
                        folders={folders}
                        selectedOptions={[values.id]}
                        onOptionSelect={(_, data) => {
                            setErrors(undefined)
                            setFieldValue('id', data.optionValue)
                        }}
                    />
                </Field>
            )}
            {!values.create && ![undefined, props.currentReplication?.id].includes(values.id) && file.loaded && (
                <Alert intent="error">
                    De geselecteerde map is al gekoppeld aan dossier &quot;{file.data?.name}&quot; en zal herkoppeld
                    worden aan dossier &quot;{props.file.data.reference}: {props.file.data.name}
                    &quot;.
                </Alert>
            )}
        </Form>
    )
}
